/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { getPayloadObject, getTelemetryAttributes, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IAddressButton {
    className: string;
    text: string;
    ariaLabel: string;
    disabled?: boolean;
    telemetryContent?: ITelemetryContent;
    role?: string;
    onClick(event: React.MouseEvent<HTMLElement>): void;
}

/**
 * Address button.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressButtonFunctionComponent: React.FC<IAddressButton> = (props: IAddressButton) => {
    const { className, text, ariaLabel, disabled: isDisabled, telemetryContent, onClick, role } = props;
    const payLoad = getPayloadObject('click', telemetryContent!, text);
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);
    return (
        <button className={className} aria-label={ariaLabel} disabled={isDisabled} role={role} onClick={onClick} {...attributes}>
            {text}
        </button>
    );
};

export default AddressButtonFunctionComponent;
